namespace DateUtils {
	export function now():number {
		if (Date.now) {
			return Date.now();
		} else {
			return (new Date()).getTime();
		}
	}
}